(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('cart-drawer')) {
    customElements.define(
      'cart-drawer',
      class CartDrawer extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('[data-dialog]');
          this.status = this.querySelector('[data-drawer-status]');

          this.addEventListener('click', (event) => {
            if (event.target.closest('[data-drawer-close]')) this.close();
            const remove = event.target.closest('[data-remove]');
            if (remove) this.change(remove.closest('[data-line]').dataset.line, 0);
          });

          /* Clicking the backdrop closes the drawer. */
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.close();
          });

          this.dialog.addEventListener('close', () => {
            document.documentElement.classList.remove('scroll-locked');
            this.opener?.focus?.();
          });

          this.addEventListener('change', (event) => {
            const input = event.target.closest('.quantity__input');
            if (!input) return;
            clearTimeout(this.timer);
            this.timer = setTimeout(() => this.change(input.closest('[data-line]').dataset.line, input.value), 350);
          });

          document.addEventListener('click', (event) => {
            const toggle = event.target.closest('[data-cart-toggle]');
            if (!toggle) return;
            event.preventDefault();
            this.open(toggle);
          });

          document.addEventListener('submit', (event) => this.onSubmit(event));
        }

        open(opener) {
          this.opener = opener || document.activeElement;
          if (!this.dialog.open) this.dialog.showModal();
          document.documentElement.classList.add('scroll-locked');
        }

        close() {
          if (this.dialog.open) this.dialog.close();
        }

        async onSubmit(event) {
          const form = event.target;
          if (!(form instanceof HTMLFormElement)) return;
          if (!form.getAttribute('action')?.includes('/cart/add')) return;
          event.preventDefault();

          const button = event.submitter || form.querySelector('[type="submit"]');
          const errorEl = form.querySelector('[data-form-error]');
          if (errorEl) errorEl.hidden = true;
          button?.classList.add('is-loading');
          button?.setAttribute('aria-busy', 'true');

          const body = new FormData(form);
          body.append('sections', 'cart-drawer');
          body.append('sections_url', window.location.pathname);

          try {
            const response = await fetch(`${this.dataset.addUrl}.js`, {
              method: 'POST',
              headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body,
            });
            const data = await response.json();

            if (!response.ok) {
              this.showFormError(errorEl, data.description || data.message);
              return;
            }
            if (!data.sections?.['cart-drawer']) {
              window.location.href = this.dataset.cartUrl;
              return;
            }
            this.render(data.sections['cart-drawer']);
            this.announce(this.dataset.addedText);
            this.open(button);
          } catch (error) {
            HTMLFormElement.prototype.submit.call(form);
          } finally {
            button?.classList.remove('is-loading');
            button?.removeAttribute('aria-busy');
          }
        }

        async change(line, quantity) {
          const focusedId = document.activeElement?.id;
          this.dialog.classList.add('is-busy');
          try {
            const response = await fetch(`${this.dataset.changeUrl}.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ line: Number(line), quantity: Number(quantity), sections: 'cart-drawer' }),
            });
            const data = await response.json();
            if (!response.ok) {
              this.announce(data.description || this.dataset.errorText);
              return;
            }
            this.render(data.sections['cart-drawer']);
            const target = (focusedId && document.getElementById(focusedId)) || this.querySelector('[data-drawer-close]');
            target?.focus();
          } catch (error) {
            this.announce(this.dataset.errorText);
          } finally {
            this.dialog.classList.remove('is-busy');
          }
        }

        render(html) {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-drawer-inner]');
          const current = this.querySelector('[data-drawer-inner]');
          if (!fresh || !current) return;
          current.replaceWith(fresh);

          const count = Number(fresh.dataset.count);
          document.querySelectorAll('[data-cart-count]').forEach((el) => {
            el.textContent = Math.min(count, 99);
            el.hidden = count === 0;
          });
          document.querySelectorAll('[data-cart-label]').forEach((el) => (el.textContent = fresh.dataset.label));
        }

        showFormError(el, message) {
          const text = message || this.dataset.errorText;
          if (el) {
            el.textContent = text;
            el.hidden = false;
          } else {
            this.announce(text);
          }
        }

        announce(message) {
          if (!this.status) return;
          this.status.textContent = '';
          requestAnimationFrame(() => (this.status.textContent = message));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const form = document.querySelector('[data-cart-form]');
    if (!form) return;

    let timer;
    form.addEventListener('change', (event) => {
      if (!event.target.matches('input[name="updates[]"]')) return;
      clearTimeout(timer);
      timer = setTimeout(() => form.requestSubmit(form.querySelector('[data-update-button]')), 500);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-site-header]');
    if (!header) return;

    const root = document.documentElement;
    const nav = header.querySelector('[data-site-nav]');
    const toggle = header.querySelector('[data-menu-toggle]');
    const desktop = window.matchMedia('(min-width: 990px)');

    const setOffset = () => {
      root.style.setProperty('--header-bottom', `${Math.max(header.getBoundingClientRect().bottom, 0)}px`);
    };

    /* Border appears once the page scrolls under a sticky header. */
    if (header.hasAttribute('data-sticky')) {
      let ticking = false;
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          header.classList.toggle('is-scrolled', window.scrollY > 4);
          ticking = false;
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    if (!nav || !toggle) return;

    const background = () =>
      [document.getElementById('MainContent'), ...document.querySelectorAll('.shopify-section-group-footer-group')].filter(Boolean);

    const focusables = () => [toggle, ...nav.querySelectorAll('a[href], button:not([disabled])')];

    const setOpen = (open) => {
      if (open) setOffset();
      nav.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? toggle.dataset.labelClose : toggle.dataset.labelOpen);
      root.classList.toggle('scroll-locked', open);
      background().forEach((el) => (el.inert = open));
      if (open) nav.querySelector('a')?.focus();
    };

    toggle.addEventListener('click', () => setOpen(!nav.classList.contains('is-open')));
    nav.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setOpen(false)));

    document.addEventListener('keydown', (event) => {
      if (!nav.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        setOpen(false);
        toggle.focus();
        return;
      }
      if (event.key !== 'Tab') return;
      const items = focusables();
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    desktop.addEventListener('change', (event) => event.matches && setOpen(false));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-hero]').forEach((hero) => {
      /* Variant swatches: keep price, compare-at, save badge and label in sync. */
      const form = hero.querySelector('.hero__form');
      const price = hero.querySelector('[data-hero-price]');
      const stickyPrice = hero.querySelector('[data-hero-sticky-price]');
      const variantTitle = hero.querySelector('[data-hero-variant-title]');

      form?.addEventListener('change', (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || input.name !== 'id' || !input.checked) return;
        const { price: current, compare, save, title } = input.dataset;

        if (price) {
          const onSale = Boolean(compare);
          price.querySelector('[data-hero-price-current]').textContent = current;
          price.querySelector('[data-hero-price-compare]').textContent = compare || '';
          price.querySelector('[data-hero-price-was]').hidden = !onSale;
          const saveEl = price.querySelector('[data-hero-save]');
          saveEl.textContent = save || '';
          saveEl.hidden = !onSale;
          price.querySelector('[data-hero-price-label]').textContent = onSale
            ? price.dataset.saleLabel
            : price.dataset.regularLabel;
        }
        if (variantTitle) variantTitle.textContent = title;
        if (stickyPrice) stickyPrice.textContent = current;
      });

      /* Sticky bar appears once the main button has scrolled above the viewport. */
      const sticky = hero.querySelector('[data-hero-sticky]');
      const buy = hero.querySelector('[data-hero-buy]');
      if (!sticky || !buy || !('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.inert = !show;
        sticky.setAttribute('aria-hidden', String(!show));
      });
      observer.observe(buy);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('product-info')) {
    customElements.define(
      'product-info',
      class ProductInfo extends HTMLElement {
        connectedCallback() {
          this.form = document.getElementById(this.dataset.formId);
          this.variantInput = this.form?.querySelector('[data-variant-input]');
          this.addButton = this.querySelector('[data-add-button]');
          this.stickyBar = this.querySelector('[data-sticky-atc]');
          this.stickyButton = this.querySelector('[data-sticky-button]');
          this.stickyPrice = this.querySelector('[data-sticky-price]');

          const variantsJson = this.querySelector('[data-variants]');
          this.variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];

          this.querySelectorAll('.variant-option').forEach((fieldset) =>
            fieldset.addEventListener('change', () => this.onOptionChange())
          );

          this.initGallery();
          this.initStickyBar();
        }

        /* ---- Variants ---- */
        selectedOptions() {
          return [...this.querySelectorAll('.variant-option')].map(
            (fieldset) => fieldset.querySelector('input:checked')?.value
          );
        }

        onOptionChange() {
          const options = this.selectedOptions();
          this.querySelectorAll('.variant-option').forEach((fieldset, index) => {
            const label = fieldset.querySelector('[data-selected-value]');
            if (label) label.textContent = options[index];
          });

          const variant = this.variants.find((v) => v.options.every((value, i) => value === options[i]));
          this.updateButtons(variant);
          if (!variant) return;

          if (this.variantInput) this.variantInput.value = variant.id;
          this.updatePrice(variant);
          if (variant.media) this.showMedia(String(variant.media));

          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }

        updatePrice(variant) {
          const price = this.querySelector('[data-price]');
          if (price) {
            const current = price.querySelector('[data-price-current]');
            const compare = price.querySelector('[data-price-compare]');
            if (current) current.textContent = variant.price;
            if (compare) compare.textContent = variant.compare || '';
            price.classList.toggle('price--on-sale', Boolean(variant.compare));
            price.querySelectorAll('.price__compare, .badge--sale').forEach((el) => (el.hidden = !variant.compare));
          }
          if (this.stickyPrice) this.stickyPrice.textContent = variant.price;
        }

        updateButtons(variant) {
          if (!this.addButton) return;
          const labels = this.addButton.dataset;
          [this.addButton, this.stickyButton].forEach((button) => {
            if (!button) return;
            button.disabled = !variant || !variant.available;
            button.textContent = !variant
              ? labels.labelUnavailable
              : variant.available
                ? labels.labelAdd
                : labels.labelSoldOut;
          });
        }

        /* ---- Gallery ---- */
        initGallery() {
          this.viewer = this.querySelector('[data-gallery-viewer]');
          if (!this.viewer) return;
          this.thumbs = [...this.querySelectorAll('[data-thumb]')];
          this.dots = [...this.querySelectorAll('.gallery__dot')];

          this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.showMedia(thumb.dataset.thumb)));

          const slides = [...this.viewer.querySelectorAll('[data-media-id]')];
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                const index = slides.indexOf(entry.target);
                this.thumbs.forEach((t, i) => t.setAttribute('aria-current', String(i === index)));
                this.dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
              });
            },
            { root: this.viewer, threshold: 0.6 }
          );
          slides.forEach((slide) => observer.observe(slide));

          this.viewer.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
            event.preventDefault();
            const direction = event.key === 'ArrowRight' ? 1 : -1;
            this.viewer.scrollBy({ left: direction * this.viewer.clientWidth, behavior: this.scrollBehavior() });
          });
        }

        showMedia(mediaId) {
          const slide = this.viewer?.querySelector(`[data-media-id="${mediaId}"]`);
          if (!slide) return;
          this.viewer.scrollTo({ left: slide.offsetLeft - this.viewer.offsetLeft, behavior: this.scrollBehavior() });
        }

        scrollBehavior() {
          return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        }

        /* ---- Sticky add to cart ---- */
        initStickyBar() {
          if (!this.stickyBar || !this.addButton) return;
          const observer = new IntersectionObserver(([entry]) => {
            const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.stickyBar.classList.toggle('is-visible', show);
            this.stickyBar.inert = !show;
            this.stickyBar.setAttribute('aria-hidden', String(!show));
          });
          observer.observe(this.addButton);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('related-products')) {
    customElements.define(
      'related-products',
      class RelatedProducts extends HTMLElement {
        connectedCallback() {
          if (this.children.length) return;
          const observer = new IntersectionObserver(
            ([entry]) => {
              if (!entry.isIntersecting) return;
              observer.disconnect();
              this.load();
            },
            { rootMargin: '0px 0px 400px 0px' }
          );
          observer.observe(this);
        }

        async load() {
          try {
            const response = await fetch(this.dataset.url);
            if (!response.ok) return;
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const fresh = html.querySelector('related-products');
            if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
          } catch (error) {
            /* Recommendations are optional; fail silently. */
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
